import {
  faMugHot,
  faHeadphones,
  faRocket,
  IconDefinition,
  faFileContract,
  faTableCells,
} from '@fortawesome/free-solid-svg-icons'

export interface HelpInfo {
  label: string
  link: string
  description: string
  icon: IconDefinition
}
export const SOC2_PDF_OBJECT_KEY =
  'public-content/2017-trust-services-criteria-with-revised-points-of-focus-2022.pdf'
export const SOC2_PDF_LINK =
  'https://www.aicpa.org/resources/download/2017-trust-services-criteria-with-revised-points-of-focus-2022'
export const ISO_LINK = 'https://www.iso.org/standard/82875.html'
export const HelpPages: Record<string, HelpInfo> = {
  Overview: {
    label: 'GRC Overview',
    link: 'https://support.trustero.com/knowledge/table-of-contents-for-knowledge-base',
    description:
      'Confused about your GRC journey? Not sure where to start or what you need to get done?',
    icon: faMugHot,
  },
  QuickStart: {
    label: 'Quick Start Guides',
    link: 'https://support.trustero.com/knowledge/trustero-quick-start-guides',
    description:
      'Know what you need, but aren’t sure how to do it with Trustero? These guides help you use Trustero to get things done.',
    icon: faRocket,
  },
  ContactSupport: {
    label: 'Contact Support',
    link: 'https://support.trustero.com/tickets-view/new',
    description: 'Need help? Send a ticket to our support team.',
    icon: faHeadphones,
  },
}

export const HelpPagesInternal: Record<string, HelpInfo> = {
  TestTable: {
    label: 'Test Table',
    link: 'https://support.trustero.com/knowledge/test-table-user-guide',
    description: 'Test Table',
    icon: faTableCells,
  },
  TrustPortal: {
    label: 'Trust Portal',
    link: 'https://support.trustero.com/knowledge/trust-portal',
    description:
      'Learn how to use the Trust Portal to securely share compliance content with 3rd parties.',
    icon: faFileContract,
  },
}
